import { Injectable, OnDestroy } from '@angular/core';
import { Log } from '@shared/debug/log';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StorageDataService implements OnDestroy {
  private _storageData: {[key:string]: BehaviorSubject<string | null>} = {}

  private onStorage = (storageEvent: StorageEvent) => {
    if(storageEvent?.key){
      this.publishNewData(storageEvent.key, storageEvent.newValue)
    }
  };

  constructor() {
    window.addEventListener('storage', this.onStorage);
  }

  public ngOnDestroy(): void {
    window.removeEventListener('storage', this.onStorage);
  }

  public getStorageData(key: string): Observable<string | null> {
    if (!(key in this._storageData)) {
      this._storageData[key] = new BehaviorSubject<string | null>(this.read(key));
    }
    return this._storageData[key].asObservable();
  }

  public read(key: string): string | null {
    return localStorage.getItem(key);
  }

  public write(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
      this.publishNewData(key, value);
    } catch (error) {
      Log.error('Error while writing data to local storage using key ' + key + ': ', error);
    }
  }

  private publishNewData(key: string, value: string | null ): void {
    if (key in this._storageData) {
      this._storageData[key].next(value);
    } else {
      this._storageData[key] = new BehaviorSubject<string | null>(value);
    }
  }
}
